module.exports = __webpack_public_path__ + "img/anchorages-chartlet.dadba39b.jpg";